<template>
    <b-container class="bv-example-row">
        <alert :message="message" />
        <b-row>
            <b-col md="12">
                <h3>List of spaces</h3>
            </b-col>
        </b-row>

        <div class="overflow-auto">

            <b-form-group label="Filter by name" label-for="filter-input" label-cols-sm="2" label-size="sm">
                <b-input-group size="sm">
                    <b-form-input id="filter-input" v-model="filter_by_space" type="search" placeholder="Type to Search"
                        v-on:keyup.enter="download_list_of_spaces"></b-form-input>

                </b-input-group>
            </b-form-group>

            <b-form-group label="Filter by uuid" label-for="filter-input" label-cols-sm="2" label-size="sm">
                <b-input-group size="sm">
                    <b-form-input id="filter-input" v-model="filter_by_uuid" type="search" placeholder="Type to Search"
                        v-on:keyup.enter="download_list_of_spaces"></b-form-input>

                </b-input-group>
            </b-form-group>

            <b-form-group label="Filter by status" label-for="filter-input" label-cols-sm="2" label-size="sm"><b-input-group
                    size="sm">
                    <b-form-select placeholder="" id="input-visible" v-model="filter_by_status" :options="space_status" />
                </b-input-group>
            </b-form-group>

            <b-button :disabled="disable_button" @click="download_list_of_spaces" variant="primary" class="mb-3">Filter
                <b-spinner v-if="disable_button" small label="Loading..." /></b-button>

            <b-table id="my-table" :items="spaces" :per-page="perPage" :fields="fields" small striped>
                <template v-slot:cell(name)="data">
                    <router-link :to="'/space/' + data.item.uuid">{{ data.value }}</router-link>
                </template>
            </b-table>

            <b-pagination v-model="currentPage" :total-rows="this.totalRows" :per-page="perPage"
                @change="download_list_of_spaces" align="fill" size="sm" class="my-0"></b-pagination>
        </div>

    </b-container>
</template>

<script>
import Alert from '../components/alert.vue';

export default {
    data() {
        return {
            message: '',
            perPage: 30,
            currentPage: 1,
            totalRows: null,
            spaces: [],
            filter_by_space: null,
            filter_by_uuid: null,
            filter_by_status: null,
            fields: [
                { key: 'name', class: 'text-center align-middle' },
                { key: 'uuid', label: 'UUID', class: 'text-center align-middle' },
                { key: 'status', class: 'text-center align-middle' },
            ],
            space_status: [
                { value: null, text: '' },
                { value: "active", text: "active" },
                { value: "disabled", text: "disabled" },
                { value: "suspended", text: "suspended" },
                { value: "locked", text: "locked" },
                { value: "unavailable", text: "unavailable" },
                { value: "scheduled to remove", text: "scheduled to remove" }
            ],
            disable_button: false,
        }
    },
    components: {
        alert: Alert,
    },
    methods: {
        init() {
            this.download_list_of_spaces()
        },
        download_list_of_spaces(value = 1) {
            if (value.constructor.name != "Number") {
                value = 1
            }
            this.disable_button = true;
            this.$http.get(this.$apiURL + '/spaces/search',
                {
                    headers: this.$store.getters.authHeader,
                    params: { name: this.filter_by_space, page_num: value, uuid: this.filter_by_uuid, status: this.filter_by_status }
                })
                .then((res) => {
                    this.spaces = res.data.items
                    this.totalRows = res.data.total_records
                })
                .catch((error) => {
                    this.message = {
                        'message': error,
                        'type': "danger"
                    }
                })
                .finally(() => {
                    this.disable_button = false;
                });
        },
    },
    created() {
        this.init();
    },
}
</script>
